import { SupportedScreenWrapper, UnsupportedScreenWrapper } from './ScreenSize.styled'

export { SupportedScreenWrapper, UnsupportedScreenWrapper }
